<template>
  <div class="plus_icon_container">
    <div class="plus_icon"></div>
  </div>
</template>

<script>
export default {

};
</script>

<style>
  .plus_icon_container {
    position: relative;
    width: 54px;
    height: 54px;
    padding: 15px;
  }

.plus_icon {
  position:relative;
  width:24px; height:24px;
}

.plus_icon:before {
  content:"";
  position:absolute;
  background: #fff;
  display:inline-block;
  margin-top:40%;
  width:20%;
  height:20%;
  margin-left:-10%;
}

.plus_icon:hover:before{
  width:100%;
  margin-left:-50%;
  background: #695c54;
}

.plus_icon:after {
  content:"";
  position:absolute;
    background: #fff;
  display:inline-block;
  margin-left:-10%;
  margin-top:40%;
  width:20%;
  height:20%;
}

.plus_icon:hover:after{
  background: #695c54;
  margin-top:0px;
  height:100%;
}

.plus_icon:before,
.plus_icon:after {
 -webkit-transition: all 0.3s ease;
 -moz-transition: all 0.3s ease;
 -ms-transition: all 0.3s ease;
 -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

</style>
